import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import Logo from './Logo';
import './Footer.css';

const Footer: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      const navbarHeight = 100;
      const elementPosition = element.offsetTop;
      const offsetPosition = elementPosition - navbarHeight;

      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  };

  const handleNavigation = (path: string, sectionId?: string) => {
    if (path === '/') {
      // Navigate to home
      if (location.pathname === '/') {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      } else {
        navigate('/');
      }
    } else if (path === '/products') {
      // Navigate to products section
      if (location.pathname === '/' || location.pathname === '/products') {
        scrollToSection('products');
      } else {
        navigate('/');
        setTimeout(() => scrollToSection('products'), 100);
      }
    } else {
      // Navigate to other pages
      navigate(path);
    }
  };

  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-content">
          <div className="footer-brand">
            <Logo size="medium" showText={false} variant="dark" />
          </div>

          <nav className="footer-nav">
            <button onClick={() => handleNavigation('/')} className="footer-link">Home</button>
            <button onClick={() => handleNavigation('/products')} className="footer-link">Products</button>
            <button onClick={() => handleNavigation('/industries')} className="footer-link">Industries</button>
            <button onClick={() => handleNavigation('/about')} className="footer-link">About</button>
            <button onClick={() => handleNavigation('/contact')} className="footer-link">Contact</button>
          </nav>
        </div>

        <div className="footer-bottom">
          <p>&copy; 2024 AxiomTeq. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer; 